
// import ContextNav, { ContextNavItem } from '../../../components/ContextNav';
var ContextNav = require('../../../components/ContextNav').ContextNav;
var ContextNavItem = require('../../../components/ContextNav').ContextNavItem;
var React = require('react');
var connect = require('react-redux').connect;
require('./Header.css');

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.toggleTableOfContents = this.toggleTableOfContents.bind(this);
  }
  componentDidMount() {
    if(typeof(document) !== 'undefined') {
      document.addEventListener('scroll', this.handleScroll);
      document.addEventListener('wheel', this.handleScroll);
    }
  }

  handleScroll() {
    if(!this.refs.header) return;
    var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    if(scrollTop > 30) {
      this.refs.header.classList.add('pubr-header--sticky');
      document.body.classList.add('pubr-sticky');
    }
    else {
      this.refs.header.classList.remove('pubr-header--sticky');
      document.body.classList.remove('pubr-sticky');
    }
    if(scrollTop > 75) {
      this.refs.header.classList.add('pubr-header--shadow');
    }
    else {
      this.refs.header.classList.remove('pubr-header--shadow');
    }
    if(scrollTop > 75) {
      this.refs.title.classList.remove('pubr-header__title--hidden');
    }
    else {
      this.refs.title.classList.add('pubr-header__title--hidden');
    }
  }

  toggleTableOfContents() {
    if(this.props.tableOfContentsExpanded) {
      document.body.classList.remove('pubr-toc-expanded');
    }
    else {
      document.body.classList.add('pubr-toc-expanded');
    }
    this.props.toggleTableOfContents();
  }

  closeApp() {
      document.dispatchEvent(new CustomEvent('pub-closing'));
  }

    render() {
    return (
        <header className="pubr-header" ref="header" aria-label={this.props.readerGui.guiLang == "sv" ? "Huvudmeny" : "Menu"}>
        <div className="pubr-header__inner">
          <nav className="pubr-header__inner__wrap">
            <div className="pubr-icon-button pubr-icon-button--nav pubr-icon-button--text">
              <button onClick={this.toggleTableOfContents}
                            id="content-nav-button"><span><span>{this.props.readerGui.tocText}</span></span></button>
            </div>
            <div className="pubr-icon-link--print">
              <a href={this.props.browserPrintUrl}
                            title={this.props.readerGui.printTitle}
                 target="_blank">&nbsp;</a>
            </div>
            
            <strong className="pubr-header__title pubr-header__title--hidden" ref="title">{this.props.title}</strong>
                    <ContextNav className="pubr-icon-button pubr-icon-button--download" customTrigger={this.props.readerGui.downloadText}>
                        <ContextNavItem text={this.props.readerGui.downloadPublicationText} handler={this.props.toggleDownloadDialogFull} />
                        <ContextNavItem text={this.props.readerGui.selectSectionText}  handler={this.props.toggleDownloadDialog} />
            </ContextNav>
            <div className="pubr-icon-button pubr-icon-button--back pubr-icon-button--text">
                        <button onClick={this.closeApp.bind(this)}><span>{this.props.readerGui.closeText}</span></button>
            </div>
          </nav>
        </div>
      </header>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      browserPrintUrl: state.reader.browserPrintUrl,
      readerGui: state.reader.readerGui
  }
}

module.exports = connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/modules/reader/components/Header.js